import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './transition.scss';

export class TransitionComponent extends Component {

    render() {
        return (
            <div className='transition'>
                <ReactCSSTransitionGroup
                    transitionAppear
                    transitionAppearTimeout={300}
                    transitionEnterTimeout={1300}
                    transitionLeaveTimeout={300}
                    transitionName='fadeIn'
                >
                    {this.props.children}
                </ReactCSSTransitionGroup>
            </div>
        );
    }

};



// WEBPACK FOOTER //
// ./src/shared/transition/transition.component.js